import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconArrowRight_24 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M5 12H19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5L19 12L12 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconArrowRight_24.displayName = 'IconArrowRight_24';
